import { InjectionToken } from '@angular/core';
import { IFmntsTableComponents } from './table.model';

/**
 * Used to provide a table to some of the sub-components without causing a circular dependency.
 */
export const FMNTS_TABLE = new InjectionToken<IFmntsTableComponents>(
  'fmnts.components.table.table-component',
);
